import { useContestContext } from '../../common/context/ContestContext/ContestContext';

const useTeamPickEmIsStandingsBySlateSupported = () => {
  const { contest } = useContestContext();

  return !!contest?.settings?.teamBasedScoringOptions;
};

export default useTeamPickEmIsStandingsBySlateSupported;
